<template>
    <modal :show="showModal" @close="closeModal">
        <div v-if="bill !== null" class="info-modal">
            <div class="info-modal-header">
                <h2>{{ !bill.group.is_perk ? bill.group.name : bill.name }}</h2>
            </div>

            <div class="info-modal-body" v-html="!bill.group.is_perk ? bill.group.description : bill.description"></div>

            <div v-if="!bill.group.is_perk" class="info-modal-footer">
                <button type="button" class="btn btn-primary" :class="buttonClass(bill.id)"  @click="toggleBill(bill.id)">{{ buttonText(bill.id) }}</button>
            </div>
        </div>
    </modal>
</template>

<script>
    import store from "../../../store/index";
    import Modal from '../../Modal';

    export default {
        name: "BillInfoModal",

        components: {
            Modal
        },

        methods: {
            closeModal() {
                store.commit('quote/hideBillInfoModal');
            },

            buttonText(id) {
                let selected = this.$store.getters['quote/getBillSelected'](id);

                if(selected) {
                    return "Remove this Bill";
                } else {
                    return "Add this Bill";
                }
            },

            buttonClass(id) {
                let selected = this.$store.getters['quote/getBillSelected'](id);

                if(selected) {
                    return "btn-secondary";
                } else {
                    return "btn-primary";
                }
            },

            toggleBill(id) {
                let selected = this.$store.getters['quote/getBillSelected'](id);

                if(selected) {
                    store.commit('quote/deselectBill', id);
                } else {
                    store.commit('quote/selectBill', id);
                }

            }

        },

        computed: {
            showModal() {
                return this.$store.getters['quote/getShowBillInfoModal'];
            },

            bill() {
                return this.$store.getters['quote/getActiveBillInfo'];
            }
        }
    }
</script>